/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-eq-null */

import { configurationActions } from "~/areas/configuration/reducers/configurationArea";
import type { EnabledFeatureToggles, FeatureToggle } from "~/client/resources/enabledFeatureToggles";
import type { FeaturesConfigurationResource } from "~/client/resources/featuresConfigurationResource";
import type { UserPermissionSetResource } from "~/client/resources/userPermissionSetResource";
import type { UserResource } from "~/client/resources/userResource";
import { UserPermissions } from "~/client/userPermissions";
import store from "~/store";
import { logger } from "./utils/logging/logger";

export class Session {
    currentUser: UserResource | null = undefined!;
    currentPermissions: UserPermissions | null = undefined!;
    featureToggles: ReadonlyArray<FeatureToggle> | null = null;
    features: FeaturesConfigurationResource | null = undefined!;

    start(user: UserResource, featureConfigurations: FeaturesConfigurationResource, featureToggles: EnabledFeatureToggles) {
        logger.info("Starting session for {user}.", { user });
        this.currentUser = user;
        this.featureToggles = featureToggles.EnabledFeatureToggles;
        this.features = featureConfigurations;
        store.dispatch(configurationActions.featuresFetched(featureConfigurations));
    }

    end() {
        if (this.currentUser) {
            logger.info("Ending session for {user}.", { user: this.currentUser });
        }
        this.currentUser = null;
        this.currentPermissions = null;
        this.featureToggles = null;
        this.features = null;
        store.dispatch(configurationActions.featuresReset());
    }

    refreshPermissions(userPermission: UserPermissionSetResource) {
        this.currentPermissions = UserPermissions.Create(userPermission.SpacePermissions, userPermission.SystemPermissions, userPermission.Teams);
    }

    isAuthenticated() {
        return this.currentUser != null;
    }
}

export default Session;
